import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// import {CustomEase} from 'gsap/CustomEase.js';
// import {SplitText} from 'gsap/SplitText.js';
gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;
      $( '#quoter__start-trigger' ).on( 'click', function() {
        $( '.quoter-form-wrapper, .introduction-page, .llgq-progress' ).addClass( 'form-open' );
      } );
      $( document ).on( 'gform_page_loaded', function( event, formId, currentPage ) {
        $( '.real-slider.noUi-target' ).on( 'change tap taphold touchmove swipe mouseenter mouseleave mousemove mouseup', function() {
          const percentage = $( '.noUi-tooltip' ).text();
          $( '.noUi-connects' ).width( percentage+'%' );
        } );
        $( '.gform_button.button' ).on( 'click', function() {
          setTimeout( () => {
            $( '.quoter-form-wrapper' ).addClass( 'confirmation-page-active' );
          }, 300 );
        } );
      } );
    },
    finalize: function() {
    },
  };
  app.registerComponent( 'quoter', COMPONENT );
} )( app );
